import { ReactElement } from 'react';
import { Delete, Edit, GeneratingTokens, LockReset } from '@mui/icons-material';
import TableActionButton from './components/TableActionButton';
import { Actions } from './types';

export const defaultActions: Record<Actions, ReactElement> = {
	[Actions.EDIT]: (
		<TableActionButton>
			<Edit />
		</TableActionButton>
	),
	[Actions.DELETE]: (
		<TableActionButton>
			<Delete />
		</TableActionButton>
	),
	[Actions.GENERATE_KEY]: (
		<TableActionButton>
			<GeneratingTokens />
		</TableActionButton>
	),
	[Actions.SEND_TEMP_PASSWORD]: (
		<TableActionButton>
			<LockReset />
		</TableActionButton>
	),
};
